var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0697632,
    y: 0.480347,
    width: 35.4491,
    height: 35.4491,
    rx: 8.60293,
    fill: "#FFF7EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5728 14.3854C15.3573 14.3854 13.5917 16.1855 13.5917 18.3665C13.5917 20.582 15.3573 22.3476 17.5728 22.3476C19.7538 22.3476 21.5539 20.582 21.5539 18.3665C21.5539 16.1855 19.7538 14.3854 17.5728 14.3854ZM17.5728 20.9628C16.1535 20.9628 14.9765 19.8204 14.9765 18.3665C14.9765 16.9471 16.1189 15.8047 17.5728 15.8047C18.9922 15.8047 20.1346 16.9471 20.1346 18.3665C20.1346 19.8204 18.9922 20.9628 17.5728 20.9628ZM22.6271 14.2469C22.6271 13.7276 22.2117 13.3122 21.6924 13.3122C21.1731 13.3122 20.7577 13.7276 20.7577 14.2469C20.7577 14.7662 21.1731 15.1816 21.6924 15.1816C22.2117 15.1816 22.6271 14.7662 22.6271 14.2469ZM25.2581 15.1816C25.1888 13.9353 24.9119 12.8275 24.0118 11.9275C23.1118 11.0274 22.004 10.7504 20.7577 10.6812C19.4768 10.612 15.6342 10.612 14.3533 10.6812C13.1071 10.7504 12.0339 11.0274 11.0992 11.9275C10.1991 12.8275 9.92218 13.9353 9.85295 15.1816C9.78371 16.4625 9.78371 20.3051 9.85295 21.586C9.92218 22.8322 10.1991 23.9054 11.0992 24.8401C12.0339 25.7402 13.1071 26.0171 14.3533 26.0864C15.6342 26.1556 19.4768 26.1556 20.7577 26.0864C22.004 26.0171 23.1118 25.7402 24.0118 24.8401C24.9119 23.9054 25.1888 22.8322 25.2581 21.586C25.3273 20.3051 25.3273 16.4625 25.2581 15.1816ZM23.5964 22.9361C23.3541 23.6285 22.8002 24.1477 22.1424 24.4247C21.1039 24.8401 18.6806 24.7362 17.5728 24.7362C16.4304 24.7362 14.0071 24.8401 13.0032 24.4247C12.3108 24.1477 11.7916 23.6285 11.5146 22.9361C11.0992 21.9322 11.2031 19.5089 11.2031 18.3665C11.2031 17.2587 11.0992 14.8354 11.5146 13.7969C11.7916 13.1391 12.3108 12.6198 13.0032 12.3429C14.0071 11.9275 16.4304 12.0313 17.5728 12.0313C18.6806 12.0313 21.1039 11.9275 22.1424 12.3429C22.8002 12.5852 23.3195 13.1391 23.5964 13.7969C24.0118 14.8354 23.908 17.2587 23.908 18.3665C23.908 19.5089 24.0118 21.9322 23.5964 22.9361Z",
    fill: "url(#paint0_radial_10_1569)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10_1569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0556 29.9664) rotate(-90) scale(20.2013 15.8097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.81e2af13da1ba4b96bc1f293ba441025.svg";
export { ForwardRef as ReactComponent };